module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_readable-stream@2.3.6@readable-stream/lib/internal/streams/stream-browser.js
// module id = ./node_modules/_readable-stream@2.3.6@readable-stream/lib/internal/streams/stream-browser.js
// module chunks = 0 1 2